import { createSelector } from 'reselect';
import {
    get, find, has, filter, values, pick,
} from 'lodash';

/**
 * Base Selectors
 */
const getEntityId = (state, id) => id;
const getEntities = (state) => state.app.database.reservationInsurances;
const getMetaEntities = (state) => state.app.metaDatabase.reservationInsurances;
const getInsurances = (state) => state.app.database.insurances;
const getReservationInsuranceNumbers = (state) => state.app.database.reservationInsuranceNumbers;
const getCurrencies = (state) => state.app.database.currencies;

/**
 * Selector Builders
 */
export const buildMetaReservationInsuranceSelector = () => createSelector([getEntityId, getMetaEntities], (entityId, metaEntities) =>
{
    if (has(metaEntities, entityId))
    {
        return metaEntities[entityId];
    }

    return {};
});

export const buildReservationInsuranceSelector = () => createSelector([getEntityId, getEntities], (entityId, entities) =>
{
    if (has(entities, entityId))
    {
        return entities[entityId];
    }

    return {};
});

export const buildReservationInsurancesSelector = () => createSelector([getEntityId, getEntities], (entityIds, entities) => values(pick(entities, entityIds)));

export const buildReservationInsurancesByReservationIdSelector = () => createSelector([getEntityId, getEntities, getInsurances, getReservationInsuranceNumbers, getCurrencies], (reservationId, reservationInsurances, insurances, reservationInsuranceNumbers, currencies) => filter(reservationInsurances, { reservation_id: reservationId }).map((reservationInsurance) => ({
    ...reservationInsurance,
    currency: find(currencies, { id: reservationInsurance.currency_id }),
    insurance: insurances[reservationInsurance.insurance_id],
    numbers: get(reservationInsuranceNumbers, `ReservationInsurance_${reservationInsurance.id}_Numbers`, {}),
})));
